import { DateValue } from '@internationalized/date';

import {
  isInstallment,
  isLineOfCredit,
} from './product';
import {
  isDefined,
} from './type';
import {
  IsFullPayoffPaymentT,
  ProductTypeT,
  UsePaymentMessagingPropsT,
} from '../types';

export const isPaymentAfterScheduledDate = (paymentDate: DateValue, scheduledDate: DateValue) => (
  paymentDate.compare(scheduledDate) > 0
);

export const isPaymentOnOrAfterScheduledDate = (paymentDate: DateValue, scheduledDate: DateValue) => (
  paymentDate.compare(scheduledDate) >= 0
);

export type PaymentMessagingLogicHelperT = (
  props: Required<Pick<UsePaymentMessagingPropsT, 'productType' | 'paymentDate' | 'scheduledDate'>>
) => boolean | undefined;

export const isInstallmentOnOrAfterScheduledDate: PaymentMessagingLogicHelperT = (props) => {
  const {
    productType,
    paymentDate,
    scheduledDate,
  } = props;

  return isInstallment(productType) && isPaymentOnOrAfterScheduledDate(paymentDate, scheduledDate);
};

export const isInstallmentBeforeScheduledDate: PaymentMessagingLogicHelperT = (props) => {
  const {
    productType,
    paymentDate,
    scheduledDate,
  } = props;

  return isInstallment(productType) && !isPaymentOnOrAfterScheduledDate(paymentDate, scheduledDate);
};

export const isLocAfterScheduledDate: PaymentMessagingLogicHelperT = (props) => {
  const {
    productType,
    paymentDate,
    scheduledDate,
  } = props;

  return isLineOfCredit(productType) && isPaymentAfterScheduledDate(paymentDate, scheduledDate);
};

export const isLocOnOrBeforeScheduledDate: PaymentMessagingLogicHelperT = (props) => {
  const {
    productType,
    paymentDate,
    scheduledDate,
  } = props;

  return isLineOfCredit(productType) && !isPaymentAfterScheduledDate(paymentDate, scheduledDate);
};

export const isPaymentBeforeDueDate = (paymentDate: DateValue, dueDate: DateValue) => (
  paymentDate.compare(dueDate) < 0
);

export const isPaymentOnOrBeforeNextDueDate = (paymentDate: DateValue, dueDate: DateValue) => {
  return paymentDate.compare(dueDate) <= 0;
};

export const isPaymentAmountLessThanDueAmount = (dueAmount: number, paymentAmount: number) => {
  return paymentAmount < dueAmount;
};

export const presentableProductType = (productType: ProductTypeT) => {
  return isLineOfCredit(productType) ? 'minimum payment' : 'next installment';
};

export const isFullPayoffPayment: IsFullPayoffPaymentT = (props) => {
  const {
    fullPayoffAmount,
    isFullPayoffDisabled,
    paymentAmount,
  } = props;

  return isDefined(fullPayoffAmount)
    && isDefined(paymentAmount)
    && !isFullPayoffDisabled
    && paymentAmount === fullPayoffAmount
  ;
};
